<div fxLayout="column" fxFlexFill>
  <dashboard-header></dashboard-header>
  <mat-sidenav-container fxFlex>
    <mat-sidenav mode="side" [opened]="isSideNavOpen$ | async" [disableClose]="true">
      <dashboard-sidenav></dashboard-sidenav>
    </mat-sidenav>
    <mat-sidenav-content *ngrxLet="selectedStudy$ as selectedStudy">
      <section
        fxFlexFill
        [ngClass]="
          selectedStudy
            ? selectedStudy?.type === StudyType.TIIM
              ? 'tiim-material-theme'
              : 'cc-material-theme'
            : 'dashboard-material-theme'
        "
      >
        <div *ngrxLet="isSideNavOpen$ as isSideNavOpen" [ngClass]="isSideNavOpen ? 'dashboard__container' : ''">
          <div [ngClass]="isSideNavOpen ? 'dashboard__container-content' : ''">
            <router-outlet></router-outlet>
          </div>
        </div>
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
